export var LocalStorage = {
    setItem: function (key, value) { return isSupported() && window.localStorage.setItem(key, JSON.stringify(value)); },
    getItem: function (key) { return (isSupported() ? JSON.parse(window.localStorage.getItem(key)) : null); },
    removeItem: function (key) { return isSupported() && window.localStorage.removeItem(key); },
};
var isSupported = function () {
    try {
        var key = 'random-key6';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=local-storage.js.map